export default class ReactionModel {
  public type: string = "";
  public userIds: string[] = [];
  public reactionCount: number = 0;
}
